import type { AIContextFile, ContextItems } from 'src/@types/ai';

export const getContextFilesMessages = (
  contextFiles: ContextItems[],
): AIContextFile[] =>
  contextFiles.map((item): AIContextFile => {
    //file upload is not yet implemented
    // if (item.type === 'file') {
    //   // return await rotaDeEnvioDeArquivo
    //   return { id: '', type: 'doc' };
    // }
    const typesMap: { [key: string]: AIContextFile['type'] } = {
      recent: 'doc',
      drive: 'doc',
      doc: 'doc',
      image: 'image',
      file: 'file',
    };
    const id =
      (item.type === 'recent'
        ? item[item.type]?.objectRef
        : item[item.type]?._id) ?? '';
    const type = typesMap[item.type];
    return { id, type };
  });
